import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { ManagementLeftMenu } from "../../components/management/left-menu/management-left-menu";
import { ManagementLeftPanel } from "../../components/management/left-panel/management-left-panel";
import { hasManagementLeftPanel } from "../../components/management/left-panel/management-left-panel-routes";
import { ManagementTopBar } from "../../components/management/top-bar/management-top-bar";
import KuikaButton from "../../components/ui-kit/kuika-button/kuika-button";
import KuikaSvg from "../../components/ui-kit/kuika-svg/kuika-svg";
import { setManagementLeftPanelCollapsed } from "../../store/management-layout/actions";
import { AppState } from "../../store/root-reducer";

export const withManagement = <P extends object>(Component: any) => {
  return (props: P) => {
    const isCollapsed: boolean = useSelector((state: AppState) => state.managementLayout.isLeftPanelCollapsed);
    const dispatch = useDispatch();
    // A route with no panel must not have a column reserved for it: the content pane is
    // position:fixed and offsets itself by the panel's width, so without this Global
    // Configurations would sit behind 281px of nothing. Same rule as the designer shell,
    // where ViewPart.LeftPanel and the panel's own ViewPart have to agree.
    const hasPanel: boolean = hasManagementLeftPanel(document.location.pathname);
    const isPanelHidden: boolean = !hasPanel || isCollapsed;
    return (
      // Column shell: the header spans the full width, everything else sits under it.
      // The content pane is position:fixed, so it offsets itself from
      // --management-topbar-height rather than participating in this flow.
      <div className="kuika-management-shell">
        <ManagementTopBar />
        <div className="kuika_layout">
          <ManagementLeftMenu />
          <div
            className={classNames("kuika-left-panel--management", {
              "kuika-left-panel--collapsed": isCollapsed
            })}
          >
            <ManagementLeftPanel />
          </div>
          <div
            className={classNames("kuika_managementContent", {
              "kuika_managementContent--collapsed": isPanelHidden
            })}
          >
            {/* Collapsing clips the panel to zero width, taking its collapse button with
                it, so the control that re-opens it lives here instead — pinned to the
                content's left edge, the same edge tab the designer uses. */}
            {hasPanel && isCollapsed && (
              <div className="kuika-panel-expand-tab kuika-panel-expand-tab--left">
                <KuikaButton
                  data-testid="leftPanelExpandTab"
                  data-onboarding-id="management-left-panel-expand"
                  type="secondary"
                  size="md"
                  isIcon
                  aria-label="Expand panel"
                  style={{ boxShadow: "var(--shadow-sm)" }}
                  onClick={() => dispatch(setManagementLeftPanelCollapsed(false))}
                >
                  <KuikaSvg name="layout-sidebar-left-expand" type="sidebar-icons" width={16} height={16} pointer />
                </KuikaButton>
              </div>
            )}
            <Component {...props} />
          </div>
        </div>
      </div>
    );
  };
};
